




































































































































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import url from 'url';
import { ISetting } from '../services/models/Setting';

interface KeyValue {
    key: string;
    value: string;
}

@Component
export default class RTMP extends Vue {
    private lurls: any[] = [];
    private parameters: { [key: string]: string } = {};
    private parameterBTName: string[] = [];
    private Ttl: number = 1;
    private pathname: string = '';
    private pathnames: string[] = [];
    private stream: string = '';
    private showNetworkBindings: boolean = false;
    private parametersIndex: { [key: number]: { [key: string]: string } } = {};


    @Prop({default: []}) private urls!: string[];
    @Prop({default: ''}) private mode!: string;
    @Prop({default: ''}) private id!: string;
    @Prop({ default: [] }) private settings!: ISetting[];
    @Prop({ default: {} }) private networkDevices!: { [key: string]: string };
    @Prop({ default: '' }) private AdvancedLockText!: string;
    @Prop({ default: true }) private advancedLock!: boolean;

    private EncryptionTypes: any[] = [
        { value: 0, text : 'ZIXI_AES_128' },
        { value: 1, text : 'ZIXI_AES_192' },
        { value: 2, text : 'ZIXI_AES_256' },
        { value: 3, text : 'ZIXI_CHACHA20' },
        { value: 4, text : 'ZIXI_NO_ENCRYPTION' }, // fast cipher for platforms without AES-NI
    ];

    private LogLevels: any[] = [
        { value: -1, text : 'ZIXI_LOG_NONE' },
        { value: 0, text : 'ZIXI_LOG_ALL' },
        { value: 1, text : 'ZIXI_LOG_DEBUG' },
        { value: 2, text : 'ZIXI_LOG_INFO' },
        { value: 3, text : 'ZIXI_LOG_WARNINGS' },
        { value: 4, text : 'ZIXI_LOG_ERRORS' },
        { value: 5, text : 'ZIXI_LOG_FATAL' },
    ];

    @Emit()
    private configurationChanged(newValue: string[]) {
        // dummy
    }

    @Emit()
    private typeChange(newUrl: string) {
        // dummy
    }

    @Watch('settings', { immediate: true})
    private onSettingsCahnge(newValue: ISetting[], oldValue: ISetting[]) {
        if (newValue && Array.isArray(newValue)) {
            for (const s of newValue) {
                if (s.key === 'server.nic_bindings_show' && s.value.toLowerCase() === 'true') {
                    this.showNetworkBindings = true;
                }
            }
        }
    }

    @Watch('urls', { immediate: true })
    private onURLSChange(newValue: string[], oldValue: string[]) {
        if (newValue) {
            this.lurls = [];
            this.parameters = {};
            this.pathname = '';
            this.stream = '';
            let i: number = 0;

            newValue.forEach((u) => {
                const lurl: any = url.parse(u, false, false);
                this.lurls.push(lurl);
                this.parametersIndex[i] = {};

                if (lurl.pathname) {
                    this.pathnames[i] = lurl.pathname;
                    if (this.pathnames[i].startsWith('/')) {
                        this.pathnames[i] = this.pathnames[i].substring(1);
                    }
                }

                if (this.pathname === '' && lurl.pathname) {
                    this.pathname = lurl.pathname;
                    /*if (this.pathname.indexOf('/') !== -1 && this.pathname[this.pathname.length - 1] !== '/') {
                       // this.stream = this.pathname.substring(this.pathname.lastIndexOf('/'));
                        this.pathname = this.pathname.substring(1, this.pathname.lastIndexOf('/'));

                    }*/

                    if (this.pathname.startsWith('/')) {
                        this.pathname = this.pathname.substring(1);
                    }

                  /*  if (this.pathname.length > 0 && this.pathname[0] === '/') {
                        this.pathname = this.pathname.substring(1);
                    }

                    if (this.pathname.length > 0 && this.pathname[this.pathname.length - 1] === '/') {
                        this.pathname = this.pathname.substring(0, this.pathname.length - 1);
                    }*/

                    /*if (this.stream.length > 0 && this.stream[0] === '/') {
                        this.stream = this.stream.substring(1);
                    }*/

                   /* if (this.stream.length > 0 && this.stream[this.stream.length - 1] === '/') {
                        this.stream = this.stream.substring(0, this.stream.length - 1);
                    }*/

                }

                // if (0 === i) {
                let params: string[] = [];
                if (lurl && lurl.query && lurl.query.indexOf('&') !== -1) {
                    params = lurl.query.split('&');
                } else if (lurl && lurl.query && lurl.query.indexOf('=') !== -1) {
                    params.push(lurl.query);
                }

                params.forEach((param) => {
                    if (param.indexOf('=') !== -1) {
                        const values = param.split('=');
                        if (values.length > 1) {
                            if (values.length === 2) {
                                this.parameters[values[0].toLowerCase()] = values[1];
                                this.parametersIndex[i][values[0].toLowerCase()] = values[1];
                            } else {
                                this.parameters[values[0].toLowerCase()] = values.join('=').replace(`${values[0]}=`, '');
                                this.parametersIndex[i][values[0].toLowerCase()] = values.join('=').replace(`${values[0]}=`, '');
                            }
                        } else {
                            this.parameters[values[0].toLowerCase()] = 'true';
                            this.parametersIndex[i][values[0].toLowerCase()] = 'true';
                        }
                    } else {
                        this.parameters[param.toLowerCase()] = 'true';
                        this.parametersIndex[i][param.toLowerCase()] = 'true';
                    }
                });
               // }
               /* {
                    let params: string[] = [];
                    if (lurl && lurl.query && lurl.query.indexOf('&') !== -1) {
                        params = lurl.query.split('&');
                    } else if (lurl && lurl.query && lurl.query.indexOf('=') !== -1) {
                        params.push(lurl.query);
                    }
                    params.forEach((param) => {
                        if (param.indexOf('=') !== -1) {
                            const values = param.split('=');
                            if (values.length > 1 && values[0].toLowerCase() === 'bt_name') {
                                this.parameterBTName[i] = values[1];
                            }
                        }
                    });
                }*/
                i++;
            });
            const ttl = 'ttl';
            this.Ttl = parseInt(this.parameters[ttl], 10);
        }
    }

    private remove() {
        this.configurationChanged([]);
    }

    private removeAddress(index: number) {
        Vue.delete(this.lurls, index);
    }

    private addAddress() {
        Vue.set(this.lurls, this.lurls.length, url.parse('zixi://:2077', false, false));
    }

    private Address(index: number): string {
        if (this.lurls && this.lurls.length > 0) {
            return this.lurls[index].hostname;
        }

        return '';
    }
    private Port(index: number, secure: boolean|null = null): number {
        if (this.lurls && this.lurls.length > 0) {
            if (this.lurls[index].port && this.lurls[index].port !== '') {
                if (secure === null || (secure !== null && parseInt(this.lurls[index].port, 10) !== 2077 && parseInt(this.lurls[index].port, 10) !== 7077)) {
                    return this.lurls[index].port;
                }
            }

            if ((secure === null && this.Secure(index)) || (secure !== null && secure === true)) {
                return 7077;
            }

            return 2077;
        }

        return 2077;
    }

    private Secure(index: number): boolean {
        return this.lurls[index].port === 7077;
    }

    private Username(index: number): string {
        if (this.lurls[index].auth) {
            return this.lurls[index].auth.split(':')[0];
        }
        return '';
    }

    private Password(index: number): string {
        if (this.lurls[index].auth) {
            return this.lurls[index].auth.split(':')[1];
        }
        return '';
    }

    private SetSecure(secure: boolean, index: number) {
        const protocol: string = 'zixi';
        /*if (secure) {
            protocol = 'https';
        }*/

        const authenticateion = `${this.Username(index)}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
            // alert(`${protocol}://${this.Address(index)}:${this.Port(index)}/${this.pathname}/${this.stream}?${this.buildParameters(index)}`);
        Vue.set(
            this.lurls,
            index,
            url.parse(`${protocol}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${this.Port(index, secure)}/${this.Pathname(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private AddressName(index: number): string {
        if (this.parameterBTName[index]) {
            return this.parameterBTName[index];
        }

        return '';
    }

    private get NetworkDevices(): any[] {
        const ret: any[] = [];

        ret.push({
            text: 'auto',
            value: '',
        });

        Object.keys(this.networkDevices).forEach((n) => {
            ret.push({
                text: `${n} (${this.networkDevices[n]})`,
                value: this.networkDevices[n],
            });
        });

        return ret;
    }

    private get NetworkDevicesBackup(): any[] {
        const ret: any[] = [];

        ret.push({
            text: 'None',
            value: '',
        });

        Object.keys(this.networkDevices).forEach((n) => {
            ret.push({
                text: `${n} (${this.networkDevices[n]})`,
                value: this.networkDevices[n],
            });
        });

        return ret;
    }

    private Bindtodevice(index: number): string {
        const param = 'bindtodevice';
        if (this.parametersIndex[index] && this.parametersIndex[index][param]) {
            return this.parametersIndex[index][param];
        }

        return '';
    }


    private get ShowBindtodevice(): boolean {
        const param = 'bindtodevice';
        if (this.showNetworkBindings) {
            return true;
        }

        for (let i: number = 0; i < this.lurls.length; i++) {
            if (this.parametersIndex[i] && this.parametersIndex[i][param]) {
                return true;
            }
        }
        return false;
    }

    private get Application(): string {
        return this.pathname;
    }

    private get EncryptionType(): number {
        const param = 'encryption-type';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }
        return  4; // strange but it is the no encryption value
    }

    private get OnlyDTLS(): boolean {
        const param = 'only-dtls';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true';
        }
        return false;
    }

    private get IgnoreDTLSError(): boolean {
        const param = 'ignore-dtls-error';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true';
        }
        return false;
    }

    private get EncryptionKey(): string {
        const param = 'encryption-key';
        if (this.parameters[param]) {
            return this.parameters[param];
        }
        return '';
    }

     private get Latency(): number {
        const param = 'latency';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }
        return 120;
    }

    private get LogLevel(): number {
        const param = 'loglevel';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }
        return  3; // ZIXI_LOG_WARNINGS
    }

    private get BackupNIC(): string {
        const param = 'backup-nic';
        if (this.parameters[param]) {
            return this.parameters[param];
        }
        return  ''; // ZIXI_LOG_WARNINGS
    }

    private get BackupNICBonded(): boolean {
        const param = 'backup-nic-bonded';
        if (this.parameters[param]) {
            return this.parameters[param] === 'true';
        }
        return  false; // ZIXI_LOG_WARNINGS
    }

    private get FECPercentage(): number {
        const param = 'fec-percentage';
        if (this.parameters[param]) {
            return parseInt(this.parameters[param], 10);
        }
        return  15; // ZIXI_LOG_WARNINGS
    }

    private Pathname(index: number) {
        /*if (index == 0) {
            return this.pathname;
        }

        return 'hitless-1b';*/
        if (index < this.pathnames.length) {
            return this.pathnames[index];
        }

        return '';
    }

    private Protcoll(index: number): string {
        return this.lurls[index].protocol.substring(0, this.lurls[index].protocol.length - 1);
    }

    private applicationChanged(newValue: string, index: number = 0): void {
        const authenticateion = `${this.Username(index)}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${this.Port(index)}/${newValue}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private streamChanged(newValue: string, index: number = 0): void {
        const authenticateion = `${this.Username(index)}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${this.Port(index)}/${this.Pathname(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private get Stream(): string {
        return this.stream;
    }

    private get URLS(): string[] {
        return this.lurls;
    }
   /* private buildParameters(index: number = 0) {
        if (index > 0) {
            if (this.parameterBTName[index] && this.parameterBTName[index] !== '') {
                return 'bt_name=' + this.parameterBTName[index];
            }
            return '';
        }

        let ret: string = '';
        Object.keys(this.parameters).forEach(
            (key) => (ret += `${key}=${this.parameters[key]}&`),
        );

        return ret.substring(0, ret.length - 1);
    }*/
        private buildParameters(index: number = 0) {
        if (index > 0) {
         /*   if (this.parameterBTName[index] && this.parameterBTName[index] !== '') {
                return 'bt_name=' + this.parameterBTName[index];
            }*/
            // return '';
            if (this.parametersIndex[index]) {
                let r: string = '';
                Object.keys(this.parametersIndex[index]).forEach(
                    (key) => {
                        if (key === 'groupconnect') {
                            if (this.parametersIndex[index][key]) {
                                r += `${key}=1&`;
                            }
                        } else {
                            r += `${key}=${this.parametersIndex[index][key]}&`;
                        }
                    },
                );
                return r.substring(0, r.length - 1);
            }
            return '';
        }

        let ret: string = '';
        Object.keys(this.parameters).forEach(
            (key) => {
                if (key === 'groupconnect') {
                    if (this.parameters[key]) {
                        ret += `${key}=1&`;
                    }
                } else {
                    ret += `${key}=${this.parameters[key]}&`;
                }
            },
        );

        return ret.substring(0, ret.length - 1);
    }
    private addressChanged(newValue: string, index: number = 0): void {
        if (newValue.indexOf(':') !== -1 && newValue.indexOf('://') === -1) {
            if (newValue.indexOf('?') !== -1) { // also apply settings, will overwrite current settings
                this.typeChange(newValue);
                return;
            } else { // just change address and port, rest of settings are retained
                const addressAndPort = newValue.split(':');
                this.portChanged(addressAndPort[1], index);
                newValue = addressAndPort[0];
            }
        } else if (newValue.indexOf('://') !== -1 && index === 0) {
            this.typeChange(newValue);
            return;
        }
        const authenticateion = `${this.Username(index)}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(
                // @ts-ignore
                `${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${newValue}:${this.Port(index)}/${this.Pathname(index)}?${this.buildParameters(index)}`,
                false,
                false,
            ),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);     }

    private portChanged(newValue: string, index: number = 0): void {
        const authenticateion = `${this.Username(index)}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(
                `${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${
                    // @ts-ignore
                    newValue
                }/${this.Pathname(index)}?${this.buildParameters(index)}`,
                false,
                false,
            ),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private ttlChanged(newValue: string, index: number = 0): void {
        const authenticateion = `${this.Username(index)}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
        const ttl = 'ttl';
        // @ts-ignore
        Vue.set(this.parameters, ttl, newValue);
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${this.Port(index)}/${this.Pathname(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private parameterChanged(newValue: string, parameter: string, index: number = 0) {
        if (index === 0) {
            Vue.set(this.parameters, parameter, newValue);
        }
        Vue.set(this.parametersIndex[index], parameter, newValue);
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`zixi://${this.Address(index)}:${this.Port(index)}/${this.Pathname(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private usernameChanged(newValue: string, parameter: string, index: number = 0) {
        const authenticateion = `${newValue}${this.Password(index) !== '' ? ':' : ''}${this.Password(index)}@`;
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${this.Port(index)}/${this.Pathname(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private passwordChanged(newValue: string, parameter: string, index: number = 0) {
        const authenticateion = `${this.Username(index)}${newValue !== '' ? ':' : ''}${newValue}@`;
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`${this.Protcoll(index)}://${authenticateion !== '@' ? authenticateion : ''}${this.Address(index)}:${this.Port(index)}/${this.Pathname(index)}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }
}
